export default {"src":"/_next/static/media/13-pg-logo.44599b77.svg","height":30,"width":39};